var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResearchBased(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 134,
    viewBox: "0 0 200 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_749)",
    filter: "url(#filter0_i_245_749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.3738 104.08C113.978 104.08 132.302 85.7553 132.302 63.1511C132.302 40.5469 113.978 22.2227 91.3738 22.2227C68.7696 22.2227 50.4453 40.5469 50.4453 63.1511C50.4453 85.7553 68.7696 104.08 91.3738 104.08Z",
    fill: "url(#paint0_linear_245_749)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1953 84.8335H141.492C144.902 84.8335 147.667 82.3249 147.667 79.2309V75.8995C147.667 72.8055 144.902 70.2969 141.492 70.2969H52.1953C56.2798 74.348 56.3509 80.538 52.3595 84.6649L52.1953 84.8335Z",
    fill: "#D1C9C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4408 71.9619H98.3764C101.47 71.9619 103.979 74.4706 103.979 77.5646C103.979 80.6586 101.47 83.1672 98.3764 83.1672H53.4375C55.5364 79.7301 55.5317 75.3899 53.4408 71.9619Z",
    fill: "url(#paint1_linear_245_749)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2143 54.404C56.0181 54.0676 56.3154 53.6787 56.7676 53.6787H127.883C133.457 53.6787 137.975 57.4072 137.975 62.008C137.975 66.6076 133.457 70.336 127.883 70.336H56.7492C56.2947 70.336 55.9974 69.9447 56.195 69.6074C59.0099 64.7932 59.003 59.1963 56.2143 54.404V54.404Z",
    fill: "#D1C9C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7808 55.4707H104.496C108.02 55.4707 110.878 58.3283 110.878 61.8525V62.3311C110.878 65.8554 108.02 68.7129 104.496 68.7129H56.6797C58.8177 64.4692 58.8406 59.7123 56.7808 55.4707Z",
    fill: "url(#paint2_linear_245_749)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.763 52.9379H96.8689C92.7996 52.9379 89.5 49.3803 89.5 44.9919C89.5 40.6035 92.7996 37.0459 96.8689 37.0459H142.763C139.254 41.4515 139.118 47.9137 142.436 52.487L142.763 52.9379Z",
    fill: "url(#paint3_linear_245_749)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1046 44.9927C90.1046 40.6042 93.4417 37.0467 97.5582 37.0467H143.598C143.812 37.0467 143.986 36.8595 143.985 36.6311C143.982 36.404 143.809 36.2227 143.598 36.2227H70.5619C66.0186 36.2227 62.3359 40.1487 62.3359 44.9927C62.3359 49.8367 66.0186 53.7627 70.5619 53.7627H143.598C143.81 53.7627 143.982 53.5802 143.985 53.3553C143.987 53.1269 143.813 52.9398 143.598 52.9398H97.5582C93.4417 52.9387 90.1046 49.3811 90.1046 44.9927Z",
    fill: "#D1C9C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0765 62.4297C83.0765 61.5097 84.2416 60.7637 85.6774 60.7637H91.4008C90.311 60.7637 89.4283 61.3295 89.4283 62.0275L89.4554 79.8846L86.2932 77.5881L83.0703 79.8846L83.0765 62.4297V62.4297Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 84.8037H162.686C166.806 84.8037 170.147 88.1444 170.147 92.2642V98.5393C170.147 102.659 166.806 106 162.686 106H30L30.07 105.928C35.746 100.02 35.7151 90.6748 30 84.8037Z",
    fill: "#D1C9C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3516 87.9414H103.283C107.403 87.9414 110.743 91.2821 110.743 95.4019C110.743 99.5219 107.403 102.863 103.283 102.863H32.3527C34.9602 98.2423 34.9567 92.557 32.3516 87.9414Z",
    fill: "url(#paint4_linear_245_749)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.441 32.6671C54.116 32.6671 54.6632 32.1199 54.6632 31.4449C54.6632 30.7699 54.116 30.2227 53.441 30.2227C52.766 30.2227 52.2188 30.7699 52.2188 31.4449C52.2188 32.1199 52.766 32.6671 53.441 32.6671Z",
    stroke: "#E1E4E5",
    strokeWidth: 3.312,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.072 61.6988C145.663 61.6988 146.143 61.219 146.143 60.6272C146.143 60.0354 145.663 59.5557 145.072 59.5557C144.48 59.5557 144 60.0354 144 60.6272C144 61.219 144.48 61.6988 145.072 61.6988Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.649 29.0242L126.406 30.2922L126.612 26.8159L129.854 25.5488L129.649 29.0242V29.0242Z",
    stroke: "#E1E4E5",
    strokeWidth: 4.206,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5394 77.3049C45.4048 76.5483 45.6519 75.0287 45.6519 75.0287C45.6519 75.0287 43.9748 74.9138 43.1097 75.6705C42.2443 76.4274 41.8623 77.4069 42.2574 77.8585C42.6526 78.31 43.6739 78.0623 44.5394 77.3049ZM156.029 79.0054C154.719 77.8591 154.345 75.5578 154.345 75.5578C154.345 75.5578 156.885 75.3838 158.195 76.53C159.505 77.676 160.084 79.1598 159.486 79.8436C158.887 80.5276 157.341 80.1525 156.029 79.0054Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7334 61.8116C34.88 62.6322 34.8535 63.9892 35.674 64.8425C36.4946 65.6958 37.8516 65.7224 38.7049 64.9018C39.5582 64.0812 39.5848 62.7243 38.7642 61.8709C37.9436 61.0176 36.5867 60.991 35.7334 61.8116Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.154 67.037C157.749 67.61 157.768 68.5574 157.195 69.1532C156.622 69.749 155.675 69.7676 155.079 69.1946C154.483 68.6217 154.464 67.6742 155.037 67.0784C155.61 66.4826 156.558 66.4641 157.154 67.037Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6046 48.0932L41.3359 45.8245L43.6046 43.5559L45.8733 45.8245L43.6046 48.0932ZM152.271 47.2043L154.54 44.9357L152.271 42.667L150.003 44.9357L152.271 47.2043V47.2043Z",
    stroke: "#E1E4E5",
    strokeWidth: 5.42,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_245_749",
    x: 0,
    y: 0,
    width: 200,
    height: 137.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_245_749"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_245_749",
    x1: 93.1191,
    y1: 149.973,
    x2: 90.5949,
    y2: -66.8236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_245_749",
    x1: 77.6306,
    y1: 89.4495,
    x2: 77.7073,
    y2: 59.7688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_245_749",
    x1: 82.623,
    y1: 76.1374,
    x2: 82.7228,
    y2: 41.0609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_245_749",
    x1: 114.996,
    y1: 61.8479,
    x2: 115.142,
    y2: 19.7528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_245_749",
    x1: 69.876,
    y1: 111.228,
    x2: 69.9636,
    y2: 71.7045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 133.333,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearchBased);
export default __webpack_public_path__ + "static/media/research-based.ae7d15e0693a89d05dd027d1a0320c88.svg";
export { ForwardRef as ReactComponent };